// src/layout/MinimalLayout/index.js
import { Outlet } from 'react-router';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
  <>
    <Outlet />
  </>
);

export default MinimalLayout;
